import { useTranslation } from "react-i18next"

/**
 * Drop-in replacement for next-intl's useTranslations.
 * Usage: const t = useTranslations("namespace") — identical API to next-intl.
 *
 * Internally delegates to react-i18next, prepending the namespace to each key
 * so that t("key") resolves to t("namespace.key") in the flat translation JSON.
 */
export function useTranslations(namespace?: string) {
	const { t: i18nT } = useTranslation()

	if (!namespace) return i18nT

	// Return a wrapper that prepends the namespace
	return ((key: string, params?: Record<string, unknown>) => {
		return i18nT(`${namespace}.${key}`, params as Record<string, string>)
	}) as typeof i18nT
}
